// extracted by mini-css-extract-plugin
export default {"noScroll":"modal_noScroll__o-yq-"};